import { Button, Icon } from 'kui';
import * as React from 'react';
import { CHAT_VIEW } from './constants';
import { INavigationPanelChatProps } from './types';
import './_NavigationPanelChat.scss';
import { AnalyzeRender } from '../../../../helpers/memoizeHelper';
import { UnreadCounter } from '../../../../base/components/UnreadCounter/UnreadCounter';

// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`NavigationPanelChat`) : null;

export function NavigationPanelChat ({
    isShow,
    unread,
    onOpen,
}: INavigationPanelChatProps) {
    if (analyzeRender) analyzeRender.call(`NavigationPanelChat`);

    if (!isShow) return null;

    const Icon = require(`!!@svgr/webpack!./chat.svg`).default;

    return <div className={'navigation-panel__row navigation-panel__chats'}>
        <Button
            onClick={onOpen}
            text={CHAT_VIEW}
            variant={'icon-text'}
        >
            <Icon />
            <UnreadCounter count={unread} />
        </Button>
    </div>;
}
